// POS variation groups → menu entries. Display-only: the cart always receives the real underlying dish.
// With no active groups every dish stays a normal flat card (mandatory fallback).
export function applyVariationGroups(products, groups) {
  const active = (groups || []).filter((g) => g.active !== false && (g.options || []).length >= 2);
  if (!active.length) return products.map((p) => ({ kind: "dish", key: p.id, product: p }));
  const byId = Object.fromEntries(products.map((p) => [p.id, p]));
  const memberOf = {};
  const resolved = active.map((g) => {
    const options = g.options.map((o) => ({ ...o, product: byId[o.product_id] })).filter((o) => o.product);
    return { ...g, options };
  }).filter((g) => g.options.length >= 2);
  for (const g of resolved) for (const o of g.options) memberOf[o.product_id] = memberOf[o.product_id] || g;
  const out = [], emitted = new Set();
  for (const p of products) {
    const g = memberOf[p.id];
    if (!g) { out.push({ kind: "dish", key: p.id, product: p }); continue; }
    if (emitted.has(g.id)) continue;  // member's flat card hidden while its group is active
    emitted.add(g.id);
    out.push({ kind: "group", key: `vg-${g.id}`, group: g, product: p });
  }
  return out;
}

// Search matches a dish by name; a group matches when the parent name or any option label/dish name matches.
export function entryMatches(entry, q) {
  const s = q.trim().toLowerCase();
  if (!s) return true;
  const hit = (p) => (p.name || "").toLowerCase().includes(s);
  if (entry.kind === "dish") return hit(entry.product);
  return entry.group.name.toLowerCase().includes(s) || entry.group.options.some((o) => o.label.toLowerCase().includes(s) || hit(o.product));
}
